import axios, { AxiosInstance } from "axios";
import { clearUser, updateUser } from "@/hooks/useUser.ts";
import config from "@/config.ts";

let _token: string | null = localStorage.getItem("token");

export const checkAuthenticationStatus = async () => {
  const token = window.localStorage.getItem("token");
  if (token) {
    _token = token;
    await updateUser();
  }
};

export const login = async ({
  accessToken,
  refreshToken,
}: {
  accessToken: string;
  refreshToken: string;
}) => {
  localStorage.setItem("token", accessToken);
  localStorage.setItem("refreshToken", refreshToken);
  _token = accessToken;
  await updateUser();
};

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  clearUser();
};

const refreshAccessToken = async () => {
  try {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) throw new Error("No refresh token available");

    const response = await axios.post(`${config.apiBaseUrl}/token/refresh/`, {
      refreshToken,
    });
    localStorage.setItem("token", response.data.access);
    localStorage.setItem("refreshToken", response.data.refresh);
    _token = response.data.access;
  } catch (error) {
    console.error("Failed to refresh token", error);
    throw error;
  }
};

export const addAuthenticationInterceptor = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.response.use(undefined, async (error) => {
    const originalRequest = error.config;
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      try {
        const newAccessToken = await refreshAccessToken();
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        console.error("Token refresh failed, logging out...", refreshError);
        logout();
      }
    }
    return Promise.reject(error);
  });

  axiosInstance.interceptors.request.use((config) => {
    if (_token && config.headers) {
      config.headers.Authorization = `Bearer ${_token}`;
    } else {
      delete config.headers?.Authorization;
    }
    return config;
  });
};
